// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19f8B","right":"styles_right__1Zrjs"};